import * as React from 'react';
import Stack from '@mui/material/Stack';
import SaveIcon from '@mui/icons-material/Save';
import PreviewIcon from '@mui/icons-material/Preview';
import Button from '@material-ui/core/Button';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import EstimatedPaybackTime from './EstimatedPaybackTime';
import MarginOfSafetyModal from './financials/MarginOfSafetyModal';

function Valuation({data} :any) {

  function recommendationClass(decision_color) {
    if (decision_color == 'red') {
      return 'badge badge-pill valuation-badge valuation-badge-negative'
    } else if (decision_color == 'green') {
      return 'badge badge-pill valuation-badge valuation-badge-positive'
    } else {
      return 'badge badge-pill valuation-badge valuation-badge-neutral'
    }
  }

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href={ "/ticker/" + data.ticker }>{data.company_name}</a></li>
            <li className="breadcrumb-item active" aria-current="page">{data.ticker} Valuation</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-md-4 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{data.company_name} Valuation</h4>
              <p className="card-description">At a minimum of 15% return a year for the next 10 years, you can buy {data.ticker} at a margin of safety price.</p>
              <div className="table-responsive">
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td>Ticker</td>
                      <td>{data.ticker}</td>
                    </tr>
                    <tr>
                      <td><strong>Current stock price</strong></td>
                      <td>
                        <span className={ recommendationClass(data.decision_color) }>
                          {data.price_in_words}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Future price (10 years est.)</td>
                      <td>{(data.decision === 'Unpredictable') ? 'Undetermined' : data.future_market_price_in_words}</td>
                    </tr>
                    <tr>
                      <td>Fair value</td>
                      <td>{(data.decision === 'Unpredictable') ? 'Undetermined' : data.sticker_price_in_words}</td>
                    </tr>
                    <tr>
                      <td><strong>Margin of Safety Price</strong></td>
                      <td>
                        <span className="badge badge-pill valuation-badge valuation-badge-positive">
                          {(data.decision === 'Unpredictable') ? 'Undetermined' : data.margin_of_safety_in_words}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Decision</strong></td>
                      <td>
                        <span className={ recommendationClass(data.decision_color) }>
                          {data.decision}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <EstimatedPaybackTime payback_time={data.payback_time} />
        <div className="col-md-4 grid-margin stretch-card">
          <div className="card">
              <div className="card-body">
                <h4 className="card-title">what is a good price to pay for <strong>{data.company_name}</strong> stock?</h4>
                <p>
                  <MarginOfSafetyModal message="Find out its margin-of-safety price." />
                </p>
                <div className={ data?.message ? 'alert alert-success' : '' } >{data?.message}</div>
                <form className="forms-sample" action={ "/ticker/" + data.ticker + "/valuation" } method="get">
                  <div className="form-group">
                    <label>Growth rate</label>
                    <input type="number" className="form-control" step="0.01" name="growth_rate" defaultValue={data.valuation?.eps_growth_rate} />
                  </div>
                  <div className="form-group">
                    <label>Current EPS</label>
                    <input type="number" className="form-control" step="0.01" name="current_eps" defaultValue={data.valuation?.current_eps} />
                  </div>
                  <div className="form-group">
                    <label>Future PE</label> (<a href={"https://www.wolframalpha.com/input/?i=" + data.ticker + "+historical+p%2Fe"} target="_blank">View historical P/E values</a>)
                    <input type="number" className="form-control" step="0.01" name="future_pe" defaultValue={data.valuation?.future_pe} />
                  </div>
                  <Stack direction="row" spacing={2}>
                    <Button variant="contained" size="small" startIcon={< PreviewIcon />} type="submit">View</Button>
                    <Button variant="contained" size="small" startIcon={< SaveIcon />} type="submit" name="save_valuation" value="true">Save</Button>
                    <Button variant="contained" size="small" startIcon={< RestartAltIcon />}  type="submit" name="reset_valuation" value="true">Reset</Button>
                  </Stack>
                </form>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Valuation;
